






















import {Component, namespace, Prop, Vue} from "nuxt-property-decorator";
import {
  namespace as cartStore,
  actionType as cartActionType,
  IAddItemToCartBody,
} from "../../node_modules/sitis-nuxt/lib/store/modules/cart-store";
import {IProduct} from "../../node_modules/sitis-nuxt/lib/entities/product-entity";

const CartStore = namespace(cartStore);

@Component
export default class ProductToCartButton extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  private readonly product!: IProduct;
  @Prop({
    type: Boolean,
    default: false
  })
  private readonly isAddedToCart!: Boolean;
  @Prop({
    type: Boolean,
    default: false
  })
  private readonly isMobile!: Boolean;

  loading = false;
  $toast: any;
  $vkGoalWr: any;
  $customNotification: any;
  $yandexCommerce: any;

  @CartStore.Action(cartActionType.GET_CART)
  readonly getCart!: () => void;

  @CartStore.Action(cartActionType.PUT_TO_CART)
  readonly putToCart!: (item: IAddItemToCartBody) => Promise<boolean>;

  async toCart(): Promise<void> {
    const item: IAddItemToCartBody = {
      productId: this.product.id,
      quantity: 1 as number,
    };
    this.loading = true;
    const request = new Promise((resolve, reject) => {
      this.putToCart(item)
        .then((isSuccess: boolean) => {
          this.loading = false;
          if (isSuccess) {
            resolve(item);

            this.$emit('event');

            this.$yandexCommerce("add", [
              {...this.product, ...item}
            ]);

            return;
          }
          reject();
        })
        .catch(reject);
    });

    try {
      await request;
      await this.getCart();
      await this.$store.dispatch("mindbox/productCartChange");

      this.$vkGoalWr("AddFCard", {}, process.env.vkPixelCode);
    } catch (e) {
      this.$customNotification.error("Ошибка добавления товара", {
        position: "top-center",
      });
    }
  }
}
